import React from 'react';

const LoaderWithText = ({ text, isRounded, type2, className= '' }) => {
  return type2 ? (
    <div className={'bg-white-loader' + (isRounded ? ' rounded-t-[25px]' : '') + className }>
      <div className="dot-spinner">
        <div className="dot-spinner__dot"></div>
        <div className="dot-spinner__dot"></div>
        <div className="dot-spinner__dot"></div>
        <div className="dot-spinner__dot"></div>
        <div className="dot-spinner__dot"></div>
        <div className="dot-spinner__dot"></div>
        <div className="dot-spinner__dot"></div>
        <div className="dot-spinner__dot"></div>
      </div>
      <div className="geomanistMedium text-center text-gray-500 text-[16px]">{text}</div>
    </div>
  ) : 
    
  (
    <div
      className={`${isRounded ? 'rounded-t-[25px]' : ''} new_loading_container ${className}`}
    >
      <svg className="svg" viewBox="25 25 50 50">
        <circle className="circle" r="20" cy="50" cx="50" />
      </svg>
      <div className="new_loading_text">{text}</div>
    </div>
  )
};

export default LoaderWithText;
